export default function Description({
    description,
    containerClass = "text-xs text-gray-500 mt-2",
}) {
    return description && <p className={containerClass}>{description}</p>;
}
